import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Pagination } from '../../../models/pagination';
import { CajaService } from '../../../services/caja.service';
import { Caja } from '../../../models/caja';

declare var $: any;
declare var JQuery: any;

@Component({
	selector: 'caja-modal',
	templateUrl: './caja-modal.component.html',
	styleUrls: ['./caja-modal.component.css'],
	providers: [CajaService]
})
export class CajaModalComponent implements OnInit {
	@Output() onSelectItem = new EventEmitter();
	@Input() qs: String = "";
	public selectedRow: Number;
    public pagination: Pagination;
    public caja: Caja;
	public cajas: Array<Caja>;
	public loading = false;

	constructor(
        public bsModalRef: BsModalRef,
        public cajaService: CajaService,
	) {
        this.pagination = new Pagination();
        this.caja = new Caja();
        this.cajas = [];
	}

	ngOnInit() {
		this.getCajas();
	}

	getCajasBySearch(text){
		let qs = "&q[nombre]=" + text + "&q[punto_emision]=" + text;
		this.pagination.current_page = 1;
		this.getCajas(qs);
	}

	getCajas(qs = ""){
		this.loading = true;
		this.cajaService.getAll("?per_page=10&embed=sucursal"  + qs).subscribe(
			res => {
				this.loading = false;
				if (!res.data.length) {
					this.cajas = [];
				} else {
					this.cajas = res.data;

					this.pagination.current_page = res.current_page;
					this.pagination.from = res.from;
					this.pagination.to = res.to;
					this.pagination.total = res.total;
					this.pagination.last_page = res.last_page;
					this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
					this.pagination.prev_disabled = this.pagination.current_page === 1;
				}
			},	
			err => {
				this.loading = false;
				this.cajas = [];
			}
		);
	}

	onSelectRow(caja, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de usuario
		this.caja = caja;
	}

	onDBLClick(usuario,i){
		this.onSelectRow(usuario,i);
		this.onSubmit();
	}

	onSubmit() {
		//envía de objecto usuario
		this.onSelectItem.emit(this.caja);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

	next(){
		this.pagination.current_page++;
		this.getCajas();
	}

	prev(){
		this.pagination.current_page--;
		this.getCajas();
	}

	first(){
		this.pagination.current_page = 1;
		this.getCajas();
	}

	last(){
		this.pagination.current_page = this.pagination.last_page;
		this.getCajas();
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/caja-modal/caja-modal.component.ts